import { connect } from "react-redux";
import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { resetModalClearCart, actionClearCart } from "../../redux/cart/action";

const ModalConfirmClearCart = ({
  modalConfirmClearCart,
  resetModalClearCart,
  actionClearCart,
}) => {
  return (
    <Modal centered isOpen={modalConfirmClearCart} toggle={resetModalClearCart}>
      <ModalHeader toggle={resetModalClearCart}>Conferma</ModalHeader>
      <ModalBody> Sei sicuro di voler svuotare il tuo carrello?</ModalBody>
      <ModalFooter>
        <Button onClick={resetModalClearCart} color="secondary">
          Annulla
        </Button>
        <Button onClick={actionClearCart} color="primary">
          Si, sono sicuro
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    modalConfirmClearCart: state.cartReducer.modalConfirmClearCart,
  };
};

export default connect(mapStateToProps, {
  resetModalClearCart,
  actionClearCart,
})(ModalConfirmClearCart);
